import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
// import { TextAreaField } from "../../../formElements/TextAreaField";
// import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
// import { validateTextArea } from "../../../../common/Validations";
import FailureModal from "./FailureModal";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import ItemService from "../../../../services/customer_appCommonService";
import toast from "react-hot-toast";

// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";

const EstimationDeactivateModel = React.forwardRef((props, ref) => {
  // const dispatch = useDispatch();
  const { selectedRows } = props;
  // console.log(">>selectedRows", selectedRows);
  const selectedRowsFlag = props.selectedRows.length > 0;
  const [formInputs, setFormInputs] = useState({
    supplierIds: [],
    remark: "",
  });
  
  // eslint-disable-next-line
  const [errorMsg, setErrorMsg] = useState("");

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  // eslint-disable-next-line 
  const [getErrorFields, setErrorFields] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");


  useEffect(() => {
    if (props.show) {
      setFormInputs({
        supplierIds: selectedRows?.map((item) => item?.documentNumber) || [],
        remark: "",
      });
      setErrorMsg("");
    }
  }, [props.show, selectedRows]);

  // Handle Submit IviteTeamMembers
  const handleSubmit = async () => {
    console.log(">>handleSubmited")
    
    let obj = {
      documentNumber: selectedRows,
      checkerId: formInputs?.checkerNameCode,
      checkerName: formInputs?.checkerName,
    };
     await ItemService.assignEstimation(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });

        // Hide modal
        props.onHide();
        // if (quotationRequest?.transactionCodeType === "QTN") {
          // dispatch(
          //   getQtnJobList({
          //     queryName: "Get_ENQUIRY_LIST",
          //     module: "",
          //     page: 1,
          //     per_page: 10,
          //   })
          // );
          // navigate(CustomerConstants.CUSTOMER_V4_HB_ENTRY_LIST);
        // } else if (quotationRequest?.transactionCodeType === "JB") {
        //   navigate(CustomerConstants.CUSTOMER_V4_HB_JOB_LIST);
        // }
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      // setDisabled(false);
    });
    // console.log(">>payload",payload)
    // let requiredFields = [];
    // if (formInputs?.checkerName !== "") {
    //   if (!validateTextArea(formInputs?.checkerName)) {
    //     requiredFields.push("* Remarks should be below 500 characters.");
    //     setErrorFields(requiredFields);
    //     setShowFailureModal(true);
    //     return;
    //   }
    //   let payload = {
    //     documentNumber: selectedRows,
    //     checkerId: formInputs?.checkerNameCode,
    //     checkerName: formInputs?.checkerName,
    //   };
    //   console.log(">>payload", payload);
    //   props.onSubmit(payload);
    //   props.onHide();
    // } else {
    //   setErrorMsg("*Please enter the remarks");
    //   alert("Please select checker name")
    // }
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };


useEffect(() => {
    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.checkerNameCode,
      // [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    }));
  }, [getDropdownData]);
  const [checkerNameOptions, setCheckerNameOptions] = useState([]);


  // Load Checker names
  const loadCheckerNames = async () => {
    try {
      const payload = { queryName: "Get_EMPLOYEE_LIST", category: "DESIGN" };
      const response = await ItemService.generateCustomerQuery(payload);
      if (response?.status === 200) {
        const mappedData = response.data.map((emp) => ({
          checkerNameCode: emp.userId,
          name: emp.firstName,
          textDesc: emp.lastName || "",
        }));
        setCheckerNameOptions(mappedData);

        // Set default if nothing selected
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    loadCheckerNames();
    // eslint-disable-next-line
  }, []);
  //validation

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="lg"
        ref={ref}
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {selectedRowsFlag ? (
              <i class="bi bi-person-x"></i>
            ) : (
              <i className="bi bi-exclamation-triangle"></i>
            )}
            {/* <p className="subText">
          At supplier_app, every person has a role, each with its own level of
          access.
        </p> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          <form className="space-y-4">
            {!selectedRowsFlag ? (
              // Display message if no rows are selected
              <Row className="text-center">
                <Col xs={12} className="mt-3">
                  <h5>Please select at least one row.</h5>
                </Col>
                <Col xs={12} className="d-flex justify-content-end mt-3">
                  <button
                    type="button"
                    onClick={props.onHide}
                    className="btn btn-primary"
                  >
                    OK
                  </button>
                </Col>
              </Row>
            ) : (
              // Display remarks  if rows are selected
              <>
                <Row>
                  <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
                    <div className="fw-medium mb-4">
                      <p> Do you want to Assign quotation/Job? </p>{" "}
                      <Row>
                        <Col xs={5} lg={2} className="me-2">
                          <p className="bg-table-status bg-table-new-status mb-1 px-2">
                            {selectedRows}
                          </p>
                        </Col>
                        {/* {formInputs?.supplierIds.map((item, index) => (
                          <Col xs={5} lg={2} className="me-2" key={index}>
                            <p className="bg-table-status bg-table-new-status mb-1 px-2">
                            
                              {selectedRows}
                            </p>
                          </Col>
                        ))} */}
                      </Row>
                    </div>
                    {/* <TextAreaField
                      className="inputBox"
                      label=""
                      name="remark"
                      placeholder={`Please enter the  remark`}
                      value={formInputs.remark}
                      onChange={onInputChange}
                    /> */}
                    <Col xs={12} md={6} lg={4} className="commLeftRightPadding">
                      <ComboboxField
                        label="Checker Name"
                        placeholder=""
                        data={checkerNameOptions}
                        id="checkerName"
                        iconClassName="dropdownIcon"
                        name="checkerName"
                        code="checkerNameCode"
                        description="checkerNameDesc"
                        setValue={formInputs?.checkerName}
                        getvalue={setDropdownData}
                        required={true}
                        // error={validation?.checkerName}
                      />
                      {/* <ComboboxField
                            label="CheckerName"
                            placeholder=""
                            data={checkerNameOptions}
                            id="checkerName"
                            iconClassName="dropdownIcon"
                            name="checkerName"
                            code="checkerNameCode"
                            description="checkerNameDesc"
                            setValue={formInputs?.checkerName}
                            getvalue={setDropdownData}
                            required={true}
                          /> */}
                    </Col>
                  </Col>
                </Row>

                <Row className="justify-end">
                  <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                    <button
                      type="button"
                      onClick={() => props.onHide()}
                      className="btn btn-danger mt-4 w-full justify-center rounded-md"
                    >
                      No
                    </button>
                  </Col>
                  <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      className="btn btn-primary mt-4 w-full justify-center rounded-md"
                    >
                      Assign
                    </button>
                  </Col>
                  <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
                    {/* <p className="errorMsg"> {errorMsg} </p> */}
                  </Col>
                </Row>
              </>
            )}
          </form>
        </Modal.Body>
      </Modal>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </>
  );
});

export default EstimationDeactivateModel;
